module.exports = __webpack_public_path__ + "static/media/it.3fd8e0de.svg";